<input
  #inputElement
  type="range"
  [id]="id()"
  [attr.min]="min()"
  [attr.max]="max()"
  [attr.step]="step()"
  [disabled]="disabled()"
  (input)="onChangeInput()"
  [value]="value()"
  (blur)="onBlurInput()"
/>
<div style="--ticks: {{ totalTicks() - 1 }}">
  @for (tick of ticks(); track tick) {
    <span></span>
  }
</div>
